/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'

import { ENTER_MSG } from '../constants/rhybus-config'
import InputLabel from './input-label'

const InputSearch = (inputProps: any) => {
  return (
    <div className={inputProps?.formClassName}>
      {inputProps?.label && (
        <InputLabel
          className={inputProps?.inputProps?.className}
          infoLabel={inputProps?.info}
          isinfoIcon={inputProps?.infoIcon}
          isinfoLabel={inputProps?.isInfo}
          label={inputProps?.label}
          labelProps={{ htmlFor: inputProps?.inputProps?.id }}
          mandatory={inputProps?.isMandatory}
        />
      )}
      <div className={inputProps?.searchgroup}>
        {inputProps?.licon && (
          <a
            className={inputProps?.liconanchorclass}
            onChange={inputProps?.onChange}
            title={
              inputProps?.search ||
              inputProps?.inputProps?.placeholder ||
              inputProps?.label ||
              'Search'
            }
          >
            <span className={inputProps?.licon}></span>
          </a>
        )}
        <input
          aria-label={
            inputProps['aria-label'] ||
            inputProps?.inputProps?.arialabel ||
            inputProps?.label
          }
          aria-required={inputProps?.isMandatory}
          className={inputProps?.className}
          disabled={inputProps?.disabled}
          id={inputProps?.inputProps?.id}
          maxLength={inputProps?.inputProps?.maxLength}
          name={inputProps?.inputProps?.name}
          onChange={inputProps?.onChange}
          onKeyDown={inputProps?.onKeyDown}
          placeholder={inputProps?.inputProps?.placeholder}
          readOnly={inputProps?.readonly}
          size={inputProps?.inputProps?.size || 'sm'}
          style={inputProps?.style}
          type={inputProps?.type || 'search'}
          value={inputProps?.inputProps?.value}
        />
        {inputProps?.icon && (
          <a
            className={inputProps?.iconanchorclass}
            onChange={inputProps?.onChange}
            onClick={inputProps?.iconClick}
            title={
              inputProps?.send ||
              inputProps?.inputProps?.placeholder ||
              inputProps?.label ||
              'Search'
            }
          >
            <span className={inputProps?.icon}></span>
          </a>
        )}
        {inputProps?.button}
        {inputProps?.error && (
          <span className='errormsg'>
            {ENTER_MSG} {inputProps?.label || inputProps['aria-label']}
          </span>
        )}
      </div>
    </div>
  )
}
export default InputSearch
